import React from 'react';
import { addUniqueIDsToArrayItems } from 'new/utils';

import s from './TransformParameters.module.scss';

const calculateDotLevel = (level: number) => (level - 1) * 12;

const generateDotList = (level: number) => addUniqueIDsToArrayItems(Array(level).fill({}));

const renderDotList = (level: number) =>
  generateDotList(level).map(({}, idx: number) => {
    const unique = idx + 1;
    return <div key={idx} className={s.dot} aria-label={`level-${unique}`} />;
  });

const Component = ({ level, ...rest }: { level: number }) => {
  return (
    <div style={{ left: -calculateDotLevel(level) }} {...rest}>
      {renderDotList(level)}
    </div>
  );
};

const TransformParametersDotList = React.memo(
  Component,
  (prevProps, nextProps) => prevProps.level === nextProps.level,
);

export default TransformParametersDotList;
